import getDocData from './getDocData';

// Get array of doc data from collection
const getCollectionData = collection => collection.docs.map(getDocData).filter(Boolean);

export default getCollectionData;
